// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
console.log("****May new the logs be with you v.2.3.0");
import "phoenix_html"
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix"
import { LiveSocket } from "phoenix_live_view"
import topbar from "topbar"
import Alpine from "alpinejs"
import Draw from 'draw-on-canvas'

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")


// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" })
window.addEventListener("phx:page-loading-start", info => topbar.show())
window.addEventListener("phx:page-loading-stop", info => topbar.hide())
window.addEventListener("phx:next-focus", (e) => {
    let el = document.getElementById(e.detail.id);
    el.focus();
})
window.addEventListener("hp:focus", (event) => {
    // The element may be about to show up via JS.show, which wraps the
    // change in requestAnimationFrame, so we do the same to make sure
    // the focus is applied only after we change the element visibility
    requestAnimationFrame(() => {
        event.target.focus();
    });
});
window.Alpine = Alpine

window.imageViewer = function (default_image) {
    return {
        imageUrl: default_image || '/images/default-user.png',

        fileChosen(event) {
            this.fileToDataUrl(event, src => this.imageUrl = src)
        },

        fileToDataUrl(event, callback) {
            if (!event.target.files.length) return

            let file = event.target.files[0],
                reader = new FileReader()

            reader.readAsDataURL(file)
            reader.onload = e => callback(e.target.result)
        },
    }
}

let Hooks = {}
Hooks.AlpineStart = {
    mounted() {
        Alpine.start()
    }
}

Hooks.ScrollToView = {
    mounted() {
        console.log(this.el.dataset)
        if (this.el.dataset.autoScrollEnabled === "true") {
            this.el.scrollIntoView(false)
        }
    },
    updated() {
        console.log(this.el.dataset)
        if (this.el.dataset.autoScrollEnabled === "true") {
            this.el.scrollIntoView(false)
        }

    }

}

Hooks.ClickToCopy = {
    mounted() {
        this.el.addEventListener("click", e => {
            navigator.clipboard.writeText(e.target.attributes.link.value);
        })
    }
}

Hooks.InfiniteScroll = {
    loadNextLockOpen() { return this.el.dataset.loadNextLockStatus === "open" && this.el.dataset.autoScrollEnabled === "false" },
    loadPrevLockOpen() { return this.el.dataset.loadPrevLockStatus === "open" && this.el.dataset.autoScrollEnabled === "false" },
    mounted() {
        res = this.el.addEventListener("scrollend", e => {
            let targetComponent = this.el.dataset.targetComponent;
            if (this.loadPrevLockOpen() && this.scrollAt() < 10) {
                this.el.dataset.loadPrevLockStatus = "locked";
                this.pushEventTo(targetComponent, "load-prev", {})

            }
            if (this.loadNextLockOpen() && this.scrollAt() > 90) {
                this.el.dataset.loadNextLockStatus = "locked";
                this.pushEventTo(targetComponent, "load-next", {})
            }
        })

    },
    updated() {
        if (this.el.dataset.autoScrollEnabled === "false") {
            this.el.dataset.loadNextLockStatus = "open";
            this.el.dataset.loadPrevLockStatus = "open";
        }

    },
    scrollAt() {
        return (this.el.scrollTop / this.el.scrollTopMax) * 100
    }
}

Hooks.Draw = {
    mounted() {
        this.draw = new Draw(this.el, 480, 120, {
            backgroundColor: "white",
            strokeColor: "black",
            strokeWeight: 2
        })

        window.addEventListener("form:signature:reset", () => {
            this.draw.reset()
            this.pushEvent("form:signature:reset", {})
        })

        window.addEventListener("form:signature:save", () => {
            // el = document.getElementById("signature_image")
            // el.value = this.draw.canvas.toDataURL('image/png')
            this.pushEvent("form:signature:save", { "signature_image": this.draw.canvas.toDataURL('image/png') })
        })
    }
}
Hooks.OpenLink = {
    mounted() {
        window.addEventListener("phx:open_new_tab", (event) => {
            window.open(event.detail.url, '_blank');
        })
    }
}


const drawEvent = new Event('draw');
const animateEvent = new Event('animate');


let liveSocket = new LiveSocket("/live", Socket,
    {
        params: { _csrf_token: csrfToken },
        dom: {
            onBeforeElUpdated(from, to) {
                if (from.__x) {
                    window.Alpine.clone(from.__x, to);
                }
            }
        },
        hooks: Hooks

    })



// // connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket




const labelCurrencyFn = function (value, index, values) {
    return format("$.2s")(value);
}
const labelEuroFn = function (value, index, values) {
    return "€" + format(".2s")(value);
}







Alpine.start();
